import { verbiage } from "./payouts-report-verbiage";
import type { GroupSummariesField } from "../GroupSummaries/GroupSummaries/GroupSummaries";

interface PayoutsHeaderCell {
  id: string;
  label: string;
  sortBy: string;
}

const headerCells: PayoutsHeaderCell[] = [
  { id: 'payoutAmount', label: verbiage.fieldAmount, sortBy: 'PAYOUT_AMOUNT' },
  { id: 'locationName', label: verbiage.fieldLocation, sortBy: 'LOCATION_NAME' },
  { id: 'createdOn', label: verbiage.fieldPayoutInitiated, sortBy: 'CREATED_ON' },
  { id: 'completedOn', label: verbiage.fieldPayoutCompleted, sortBy: 'COMPLETED_ON' },
  { id: 'status', label: verbiage.fieldStatus, sortBy: 'STATUS' },
];

// Values are mutated by SupplierPayoutsReport when summary data loads
const groupSummaryFields: GroupSummariesField[] = [
  {
    title: verbiage.summaryTotalPayouts,
    value: 0,
  },
  {
    title: verbiage.summaryPayoutsCount,
    value: 0,
  },
  {
    title: verbiage.summaryTransactionCount,
    value: 0,
  },
];

export {
    headerCells,
    groupSummaryFields
}